import { render, staticRenderFns } from "./tblUpdateNews.html?vue&type=template&id=c564f112&scoped=true&"
import script from "./tblUpdateNews.ts?vue&type=script&lang=ts&"
export * from "./tblUpdateNews.ts?vue&type=script&lang=ts&"
import style0 from "./tblUpdateNews.scss?vue&type=style&index=0&id=c564f112&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c564f112",
  null
  
)

/* custom blocks */
import block0 from "./tblUpdateNews.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Ftasks%2FtblUpdateNews%2FtblUpdateNews.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBadge,VCol,VContainer,VImg,VRow,VTooltip})
